module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxwYXRoIGZpbGw9IiMwMDAwNjciIGQ9Ik0wIDBoMTcxLjE3NnY1MTJIMHoiLz4KICAgIDxwYXRoIGZpbGw9InJlZCIgZD0iTTM0MC44MjQgMEg1MTJ2NTEySDM0MC44MjR6Ii8+CiAgICA8cGF0aCBmaWxsPSIjZmYwIiBkPSJNMTcxLjE3NiAwaDE2OS42NDh2NTEySDE3MS4xNzZ6Ii8+CiAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/td.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/td.svg
// module chunks = 0